import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ReadMoreSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ReadMoreSVG;
